/**
 * @author      autogenerated
 * @copyright   Copyright (c) 2025, Zumper
 * @description TenantFeature
 */

export enum TenantFeature {
  /** @deprecated */
  RENT_PAYMENTS = 1,
  M3_ACTIVE = 2,
}

Object.defineProperty(TenantFeature, '__ENUM_NAME', {
  value: 'TenantFeature',
  writable: false,
  configurable: false,
  enumerable: false,
})
